export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";